module.exports = __webpack_public_path__ + "img/avatar.1546ac57.jpg";